<template>
    <v-dialog v-model="showDialog" max-width="500px" max-height="300"
    :fullscreen="$vuetify.display.xs"
     @afterLeave="closeDialog()">
     <v-container    class="py-0" >
    <v-row no-gutters  align="start" justify="center" >
    <v-col cols="auto" >
      <v-card
        class="ma-0 pa-0"

        max-width="500"
        title="Вы не выбрали сервер"
        subtitle="Необходимо выбрать сервер"

        elevation="1">
        <template v-slot:append>
        <v-btn icon="$close" variant="text" @click="closeDialog"></v-btn>
        </template>
        <template v-slot:prepend>
          <v-avatar color="blue-lighten-1" size="large">
            <v-icon icon="mdi mdi-alert" size="x-large"></v-icon>
          </v-avatar>
        </template>

        <v-card-text>
          Без выбора сервера Вы не можете пополнять или выводить адену и видеть баланс адены, подарочные коды и т. д.
        </v-card-text>

        <v-card-actions>
          <v-btn
          @click="closeDialog"
          variant="text"
           color="grey-darken-1"
           class="mr-3"
           block
          >Позже</v-btn>
        </v-card-actions>

      </v-card>
    </v-col>

</v-row>

</v-container>
    </v-dialog>
  </template>

  <script setup>


  import { computed } from 'vue';
  import { useDialogStore } from '../../../stores/dialogStore';


  const dialogStore = useDialogStore()
  const showDialog = computed({
  get: () => dialogStore.dialog_not_select_server.status,
  set: (value) => (dialogStore.dialog_not_select_server.status = value),
});


  // Деструктуризация состояний и методов из store

  const closeDialog = () => {
    dialogStore.close_dialog_not_select_server()
  };


  </script>

  <style scoped>

  @media (max-width: 600px) {
  .v-overlay__content {
    margin-left: 16px; /* Отступ слева */
    margin-right: 16px; /* Отступ справа */
    width: calc(100% - 32px); /* Ширина диалога с учетом отступов */
    max-width: none; /* Убираем ограничение по максимальной ширине */
    display: flex;
    align-items: center; /* Выравнивание по вертикали */
    justify-content: center; /* Выравнивание по горизонтали */
    height: 100%; /* Занимает всю высоту */
  }

  .v-card {
    width: 100%; /* Карточка занимает всю ширину контейнера */
  }
}
  </style>
